import React from "react"
import { Input, View, Text, Window } from "react-ame-components"

export class InputExample extends React.Component {
  state = {
    inputValue: "",
    inputMask: "",
    inputDinamycMask: "",
    inputPassword: "",
    inputSearch: "",
    inputFile: "",
    inputMultiline: "",
    inputError: "",
    inputSuccess: "",
    inputDisabled: "Valor Preenchido",
  }

  render() {
    return (
      <Window>
        <View
          direction="column"
          padding="large">
          <View marginTop="medium">
            <Text
              fontSize="medium"
              color="warning"
              fontWeight="bold">
              Componentes Input
            </Text>
          </View>
          <View marginTop="medium">
            <Text>O exemplo abaixo mostra um input padrão:</Text>
          </View>
          <View marginTop="medium">
            <Input
              placeholder="Digite seu nome:"
              value={this.state.inputValue}
              onChange={e => this.setState({ inputValue: e })}
              dataCy="test-input-base"
            />
          </View>
          <View marginTop="medium">
            <Text>O exemplo abaixo mostra um input com multiline:</Text>
          </View>
          <View marginTop="medium">
            <Input
              value={this.state.inputMultiline}
              onChange={e => this.setState({ inputMultiline: e })}
              multiline
              placeholder="Comentário"
              dataCy="test-input-multiline"
            />
          </View>
          <View marginTop="medium">
            <Text>O exemplo abaixo mostra um input com mask:</Text>
          </View>
          <View marginTop="medium">
            <Input
              placeholder="Número de telefone:"
              value={this.state.inputMask}
              onChange={e => this.setState({ inputMask: e })}
              onBlur={() => console.log("Blur")}
              mask="(00) 0 0000-0000"
              rightIcon="agenda-outline"
              dataCy="test-input-icon"
            />
          </View>
          <View marginTop="medium">
            <Text>O exemplo abaixo mostra um input com mask dinâmica:</Text>
          </View>
          <View marginTop="medium">
            <Input
              placeholder="CPF/CNPJ:"
              value={this.state.inputMultiMask}
              onChange={e => this.setState({ inputMultiMask: e })}
              onBlur={() => console.log("Blur")}
              mask={[
                "000.000.000-00",
                "00.000.000/0000-00",
                "00.000.000/0000-00--000",
              ]}
              dataCy="test-input-mask"
            />
          </View>
          <View marginTop="medium">
            <Text>
              O exemplo abaixo mostra um input do tipo [i]'password'[/i], que
              altera a visibilidade dos caracteres ao clicar no ícone:
            </Text>
          </View>
          <View marginTop="medium">
            <Input
              placeholder="Digite a sua senha"
              value={this.state.inputPassword}
              onChange={e => this.setState({ inputPassword: e })}
              type="password"
              hint="Escolha uma senha segura"
              dataCy="test-input-password"
            />
          </View>
          <View marginTop="medium">
            <Text>
              O exemplo abaixo mostra um input com button para selecionar o
              arquivo:
            </Text>
          </View>
          <View marginTop="medium">
            <Input
              placeholder="Escolha o arquivo"
              onChange={e => {
                this.setState({ inputFile: e.currentTarget.files[0] })
              }}
              type="file"
              accept="image/png"
              dataCy="test-input-file"
            />
          </View>
          <View marginTop="medium">
            <Text>
              No exemplo abaixo mostra um Input do tipo [i]'search'[/i]
              desabilitado:
            </Text>
          </View>
          <View marginTop="medium">
            <Input
              placeholder="Digite seu nome"
              onChange={e => {
                this.setState({ inputClick: e })
              }}
              value={this.state.inputClick}
              type="search"
              onSubmit={() => console.log("Procurando")}
              disabled
              dataCy="test-input-disabled"
            />
          </View>
        </View>
      </Window>
    )
  }
}
